var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.21 436.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1137,350.88h-17.17V322.1H1051.1v28.78h-9.41l-.22,20.18-71.88,0v11.42l83.17,0,.23-20.18h79.26l76.84,76.84V666.56l-66.84,80.81h-90.14V612.23H867.69V747.37H777.55l-66.84-80.81V439.14l76.84-76.84h79.27l.22,20.18h8.54l74.63,0V371h-9.69l-62.19,0-.22-20.18H867.85V322.1H799.14v28.78H782.82l-83.53,83.53V670.67l72.89,88.11H879.11V623.65h161.58V758.78h106.93l72.89-88.11V434.41Zm-74.46-17.36h45.87v17.36h-45.87Zm-252,0h45.87v17.36H810.56Z",
    transform: "translate(-699.29 -322.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M888.14,477.57H849.32V438.63H808.5l.47,38.95-38.9,0v40.49h38.5v38.76h40.79l-.25-39,38.62.47Zm-11.71,29.26-38.8-.47.24,39.09H820V506.69h-38.5V489l39,0L820.06,450H837.9V489h38.71Z",
    transform: "translate(-699.29 -322.1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 929.67,
    y: 545.95,
    width: 11.42,
    height: 29.65,
    transform: "translate(-329.5 1171.15) rotate(-89.7)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 978.71,
    y: 545.95,
    width: 11.42,
    height: 29.65,
    transform: "translate(-280.68 1220.21) rotate(-89.71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1076.76,518.26a22.95,22.95,0,0,0,32.46,32.45h0a22.95,22.95,0,0,0-32.46-32.45Zm24.39,24.38a11.53,11.53,0,1,1,0-16.31A11.54,11.54,0,0,1,1101.15,542.64Z",
    transform: "translate(-699.29 -322.1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1076.76,445.82a22.95,22.95,0,1,0,32.46,0A23,23,0,0,0,1076.76,445.82Zm24.39,24.38a11.53,11.53,0,1,1,0-16.31A11.54,11.54,0,0,1,1101.15,470.2Z",
    transform: "translate(-699.29 -322.1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.54,482a23,23,0,1,0,16.23-6.72A22.79,22.79,0,0,0,1040.54,482Zm27.76,16.22a11.53,11.53,0,0,1-19.68,8.16h0a11.53,11.53,0,1,1,19.68-8.16Z",
    transform: "translate(-699.29 -322.1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1145.44,514.49a23,23,0,1,0-16.23,6.72A22.81,22.81,0,0,0,1145.44,514.49Zm-24.38-8.07a11.53,11.53,0,1,1,8.15,3.38,11.47,11.47,0,0,1-8.15-3.38Z",
    transform: "translate(-699.29 -322.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessories);
export default __webpack_public_path__ + "static/media/accessories.a806d3d062dc158709e5d3958d202cb2.svg";
export { ForwardRef as ReactComponent };